module.exports = __webpack_public_path__ + "static/media/Iamclogo.27de317a.svg";